export default __webpack_public_path__ + "static/media/shopping-quote.df4b92c0.png";